var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"user-info-page",attrs:{"id":"news-page-container"}},[_c('c-banner-news'),_c('c-news-content')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }